import { Divider, Stack } from "@mui/material";
import {
  useGetCampaignDetailsQuery,
  useGetCampaignRoleMembersQuery,
} from "../../../api";
import { RoleItem } from "./RoleItem";
import { MembersUpdateValues } from "../../../types/companyTypes";
import { CustomLoader } from "../../ui/CustomLoader";
import { useStateWithSearchParams } from "../../../hooks";
import { useEffect } from "react";
import { NoContactsBlock } from "./NoContactsBlock";
import { QUERY_SEPARATOR } from "../../../constant";

type SearchParams = {
  min?: string;
  max?: string;
  roles?: string;
  data_source?: string;
  personas?: string;
};

export const CompanyRoleTable = ({
  account_id,
  setPage,
  ...rest
}: {
  isEditMode: boolean;
  account_id: string;
  setPage: (page: number) => void;
  setCommitteeSelected: React.Dispatch<React.SetStateAction<number>>;
  setClusterSelected: React.Dispatch<React.SetStateAction<number>>;
  updatedValues: {
    [key: string]: MembersUpdateValues;
  };
  updateHandler: (
    values?: MembersUpdateValues,
    allValues?: {
      [key: string]: MembersUpdateValues;
    },
  ) => void;
}) => {
  const { searchDict } = useStateWithSearchParams<SearchParams>({
    min: undefined,
    max: undefined,
    roles: undefined,
    data_source: undefined,
    personas: undefined,
  });

  const { data: campaignDetails } = useGetCampaignDetailsQuery({
    account_id: account_id!,
  });

  const { data, isLoading } = useGetCampaignRoleMembersQuery(
    {
      account_id,
      roles: searchDict.roles?.split(QUERY_SEPARATOR),
      data_source: searchDict.data_source?.split(QUERY_SEPARATOR),
      personas: searchDict.personas?.split(QUERY_SEPARATOR),
      min_percent: searchDict.min ? Number(searchDict.min) : undefined,
      max_percent: searchDict.max ? Number(searchDict.max) : undefined,
    },
    { refetchOnMountOrArgChange: true },
  );

  useEffect(() => {
    setPage(0);
  }, [
    searchDict.roles,
    searchDict.max,
    searchDict.min,
    searchDict.data_source,
    searchDict.personas,
  ]);

  if (isLoading || !data) return <CustomLoader />;

  const isFilters =
    searchDict?.min ||
    searchDict?.max ||
    searchDict?.roles ||
    searchDict?.data_source;
  const isNoMembers = data.roles.every((el) => el.total === 0);

  return (
    <Stack>
      <Divider />

      {isNoMembers && isFilters ? (
        <NoContactsBlock />
      ) : (
        <>
          {data.roles.map((role) => (
            <RoleItem
              account_id={account_id}
              key={role.id}
              {...role}
              {...rest}
              currentScraping={campaignDetails?.scraping_role}
            />
          ))}
        </>
      )}
    </Stack>
  );
};
